module.exports = __webpack_public_path__ + "img/header-weddingRingsFancy@2x.5076fdc.jpg";